import React from "react";
import ReactDOM from "react-dom";
import {
  Marker,
  Popup,
  MarkerLayer,
  MapConstant,
} from "../../../../../lib/Map";
import {
  getDispatchRouteStopsMarker,
  getDispatchUnassignedPickupMarker,
  getDispatchAssignedPickupMarker,
} from "../../../../mapComponents/mapHelper";
import {
  DispatchStopPickupPopupInfo,
  DispatchStopDeliveryPopupInfo,
} from "../../../../mapComponents/Popups";
import { getDataWithQueryString } from "../../../../../api/componentAPIs";
import { compose } from "recompose";
import { observer, inject } from "mobx-react";
import { withSnackbar } from "notistack";
import { TerminalMarker } from "../../../../mapComponents/Markers";
import MapsHelper from "../../../../../lib/Map/helper";
import Events from "../../../../../utilities/EventEmitter";
import appConstants from "../../../../../appConstants";
import ShowBestDriversDialog from "../Recommendations/ShowBestDrivers/ShowBestDriversDialog";
import DriverPopup from "../DriverPopUp";
import MapLegend from "./components/MapLegend";
import PickupAssignmentLasso from "./PickupAssignmentLasso";
import GeocodingModal from "../../../Common/Geocoding/GeoCodingModal";
import {
  getPickupCustomerData,
  getStopCustomerData,
} from "../../../Common/Geocoding/utils";
import { getPickupCountForPickupMarkerBadge } from "../../utils/utils";
import {
  getDriverMapConfig,
  isPickupOnMapActive,
  getStopMarkerColors,
  getPickupStopData,
  isPickupDriverExistInGrid,
  isPickupUnassigned,
  checkPickupExists,
  getPickupsRouteData,
} from "./utils";
import { hasStopDelayed } from "../utils";
import {autorun} from "mobx";
import { assignPickup, unassignPickup } from "../utils/pickupActions";
import { isFuturePickup, isNotAssignedPickup } from "../filterUtils";
import { withFeatureFlags } from "../../../../../userProfile/featureFlagsContext";
import {
  getPickupStatus,
  getPickupStatusTypeIcon,
} from "../utils/pickupStatusTypeIcon";
import { getSpecialNeedsOptionsWithServiceLevel } from "../../../utils";
import { PICKUP_STATUS } from "../constants";
import { WithPickupsGridFilterHOC } from "../Pickups/Grid/Filter";
import PickupPopupInfo from "./components/PickupPopupInfo";
import SpottedTrailers from "./SpottedTrailers";
import DriverMarkers from "./DriverMarker";
import RouteDirections from "./RouteDirections";
import GpsPingsManager from "./GpsPingsManager";
import { isGroupHeaders, isPickupGroupHeader } from "../Pickups/GroupPickup/utils";

@inject('DispatchStore')
@observer
class DriverMapContent extends React.Component {
  constructor(props) {
    super(props);
    this.headerId = `gridHeader_${this.props.glContainer._config.id}`;
    this.pickupSelectedOnMap = false;
    this.driversMapConfig = getDriverMapConfig(
      this.props.userData.userProfile?.columnPref
    );
    this.props.forwardedRef(this);
    this.state = {
      selectedPickups: this.props.DispatchStore.selectedGroupPickupsList,
      routeSelected: null,
      routeAnimation: this.driversMapConfig.toggles.isRouteAnimationEnabled,
      mapLegend: this.driversMapConfig.toggles.isMapLegendEnabled,
      selectedStop: null,
      selectedPickup: null,
      recommendationPickupId: null,
      geocodeCustomer: null,
      lassoUnassignedPickups: [],
      gpsManagerData: null
    };
    this.showRouteAnimation = false;
    this.enableChangePickupTerminal = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnableChangePickupTerminal
    );
    this.lassoBounds = [];
    this.isStopMarkerClicked = false;
    this.isPickupMarkerClicked = false;
    this.isPickupMarkerHover = false;
    this.isHoverStopMarker = false;
  }
  componentDidMount() {
    const { glEventHub } = this.props;
    glEventHub.on(appConstants.Event.PICKUP_SELECTED_GRID, this.pickupSelected);
    glEventHub.on(
      appConstants.Event.DISPATCH_ROUTE_SELECTED,
      this.routeSelectedOnGrid
    );
    glEventHub.on(this.headerId + "_multiSelectSelected", this.filterMapData);
    glEventHub.on("routeAnimation", this.routeAnimation);
    glEventHub.on(`${this.headerId}_geocode`, this.showGeocode);
    glEventHub.on("pickupsGridFilterChanged", this.filterPickupsOnMap);
    glEventHub.on("showRouteAnimationOnSelection", this.handleRouteAnimation);
    glEventHub.on(
      "closePickupAssignmentLasso",
      this.closePickupAssignmentLasso
    );
    glEventHub.on("ClosingSoonPickupsUpdated",this.onClosingSoonPickupsUpdated);
    Events.on(
      "showAssignPickupNotification",
      this.handleAssignPickupNotification
    );
    Events.on(
      "showPickupTerminalChangeMessage",
      this.showPickupTerminalChangeMessage
    );
    this.getPickupTerminalList();
    !this.props.DispatchStore.pickupsFilter && //on map popout, pickups filter is reset in store , therefore we need to update pickups filter to default filter(client specific) when map mounts in new window.
      this.props.DispatchStore.updatePickupsFilter(this.props.defaultFilter);
    this.autorunFilteredShipment = autorun(() => {
      if (
        this.props.DispatchStore.filteredPickupsOnMap.slice() &&
        this.lassoBounds.length
      ) {
        this.onScaleDrawingComplete(this.lassoBounds, false);
      }
    });
  }
  componentWillUnmount() {
    const { glEventHub } = this.props;
    glEventHub.off(
      appConstants.Event.PICKUP_SELECTED_GRID,
      this.pickupSelected
    );
    glEventHub.off(
      appConstants.Event.DISPATCH_ROUTE_SELECTED,
      this.routeSelectedOnGrid
    );
    glEventHub.off(this.headerId + "_multiSelectSelected", this.filterMapData);
    glEventHub.off("pickupsGridFilterChanged", this.filterPickupsOnMap);
    glEventHub.off("routeAnimation", this.routeAnimation);
    glEventHub.off(`${this.headerId}_geocode`, this.showGeocode);
    glEventHub.off("showRouteAnimationOnSelection", this.handleRouteAnimation);
    glEventHub.off(
      "closePickupAssignmentLasso",
      this.closePickupAssignmentLasso
    );
    glEventHub.off("ClosingSoonPickupsUpdated",this.onClosingSoonPickupsUpdated);
    Events.removeListener(
      "showAssignPickupNotification",
      this.handleAssignPickupNotification
    );
    Events.removeListener(
      "showPickupTerminalChangeMessage",
      this.showPickupTerminalChangeMessage
    );
    this.props.UpdateDispatchStore?.updateFilteredPickups();
    this.autorunFilteredShipment?.();
    this.lassoBounds = null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.selectedStop ||
      this.state.selectedPickup ||
      this.state.selectedPickups.length === 1
    ) {
      this.props.glEventHub.emit(`${this.headerId}_ActivateGeocode`, true);
    } else {
      this.props.glEventHub.emit(`${this.headerId}_ActivateGeocode`, false);
    }
    if (
      this.props.userData.userProfile.terminal.code !==
      prevProps.userData.userProfile.terminal.code
    ) {
      this.props.DispatchStore.updateSelectedDispatchDriver([]);
      this.hideAllPopups();
      this.hidePickupRecommendation();
      this.closePickupAssignmentLasso();
      this.getPickupTerminalList();
    }
  }

  onClosingSoonPickupsUpdated = () => {
    if(this.props.glContainer.layoutManager.isSubWindow){
      this.props.DispatchStore.updateClosingSoonPickups();
    }
  }
  
  showGeocode = (groupId = null) => {
    if (this.state.selectedStop?.data?.isStopCompleted) {
      this.props.enqueueSnackbar(`Not allowed to geocode a completed stop`, {
        variant: "error",
      });
      return;
    }
    this.setState({
      geocodeCustomer: this.getGeocodeCustomer(groupId),
    });
  };

  closeGeocodeModal = (locationUpdated) => {
    this.setState({
      geocodeCustomer: null,
      ...(locationUpdated ? { selectedPickup: null } : {}),
    });
  };

  filterMapData = (options) => {
    const filteredValuesList = options.map((opt) => opt.value);
    this.populateCollectedFilters(filteredValuesList);
  };

  populateCollectedFilters = (selectedOptions) => {
    this.props.DispatchStore.updateMapFilter(selectedOptions);
  };

  filterPickupsOnMap = (option) => {
    this.props.DispatchStore.updatePickupsFilter(option);
    this.isPickupMarkerClicked = false;
    this.setState({
      selectedPickup: null,
    });
  };

  pickupSelected = (selectedPickupsList) => {
    // Don't close popup if selection originated from map click
    if (!this.pickupSelectedOnMap) {
      this.isPickupMarkerClicked = false;
    }
    this.pickupSelectedOnMap = false; // Reset flag
    
    // Early return if no pickups selected
    if (!selectedPickupsList?.pickupsData?.length) {
      this.setState({
        selectedPickups: [],
        selectedPickup: null,
        recommendationPickupId: null,
      });
      return;
    }
    
    // Handle selection by groupId - collect all pickups from selected groups
    const selectedGroups = new Set();
    const uniquePickups = [];
    
    selectedPickupsList.pickupsData.forEach(pickup => {
      if (pickup.groupId && !selectedGroups.has(pickup.groupId)) {
        selectedGroups.add(pickup.groupId);
        // Get all pickups in this group
        const groupPickups = this.props.DispatchStore.pickupsList.filter(
          p => p.groupId === pickup.groupId
        );
        uniquePickups.push(...groupPickups);
      } else if (!pickup.groupId) {
        // Handle pickups without groupId
        uniquePickups.push(pickup);
      }
    });
    
    // Remove duplicates based on pickupId
    const finalPickups = uniquePickups.filter(
      (pickup, index, self) => 
        index === self.findIndex(p => p.pickupId === pickup.pickupId)
    );
    
    // Set selectedPickup for map centering - use the first pickup in the group
    const selectedPickupForCenter = finalPickups.length > 0 ? { data: finalPickups[0] } : null;
    
    this.setState({
      selectedPickups: finalPickups,
      selectedPickup: selectedPickupForCenter,
      recommendationPickupId: null,
    });
  };

  routeSelectedOnGrid = (routeSelectedList) => {
    this.isPickupMarkerClicked = false;
    this.setState((state) => ({
      selectedStop: null,
      selectedPickup:
        state.recommendationPickupId ||
        routeSelectedList.includes(state.selectedPickup?.data?.routeId)
          ? state.selectedPickup
          : null,
    }));
  };
  onScaleDrawingComplete = (bounds, isNewLasso = true) => {
    this.lassoBounds = bounds;
    const unassignedPickups = this.props.DispatchStore.filteredPickups
      .slice()
      .filter((pickup) => {
        const isNotGroupHeader = !isGroupHeaders(pickup);
        const notAssigned = isNotAssignedPickup({
          pickup,
          terminalOffset: this.props.DispatchStore.terminalOffset,
        });
        return isNotGroupHeader && notAssigned;
      })
      .map((pickup) => ({
        ...pickup,
        latitude: pickup.shipperLatitude,
        longitude: pickup.shipperLongitude,
      }));
    const lassoUnassignedPickups = MapsHelper.getLocationWithinBounds(
      bounds,
      unassignedPickups
    );
    this.setState({
      lassoUnassignedPickups,
    });
  };

  showPickupTerminalChangeMessage = (data) => {
    this.props.glEventHub.emit("DispatchEvents", "HideLoaderDialog", []);
    if (
      data.movedToTerminal == this.props.userData.userProfile.terminal.code &&
      data.movedFromTerminal
    ) {
      this.props.enqueueSnackbar(
        `${data.shipperName} moved from the terminal ${data.movedFromTerminal}.`,
        { variant: "success" }
      );
    } else if (
      data.movedFromTerminal == this.props.userData.userProfile.terminal.code &&
      data.movedToTerminal
    ) {
      this.props.enqueueSnackbar(
        `${data.shipperName} moved to the terminal ${data.movedToTerminal} successfully.`,
        { variant: "success" }
      );
      this.isPickupMarkerClicked = false;
    }
  };

  closePickupAssignmentLasso = () => {
    this.lassoBounds = [];
    this.setState({
      lassoUnassignedPickups: [],
    });
    this.props.glEventHub.emit("mapResize"); //TODO: is there any alternative of this?
    Events.emit(MapConstant.EVENT.SET_MAP_DRAW, { eventType: "clearDraw" });
  };

  routeAnimation = (routeAnimation) => {
    this.setState({
      routeAnimation,
    });
  };

  // Helper method to get all pickups in a group
  getGroupPickups = (groupId) => {
    return this.props.DispatchStore.pickupsList.filter(p => p.groupId === groupId);
  };

  // Helper method to get group header data for a pickup
  getGroupHeaderData = (groupId) => {
    return this.props.DispatchStore.pickupsList.find(
      p => p.groupId === groupId && isGroupHeaders(p)
    );
  };

  // Common method to handle pickup selection and grid sync
  handlePickupSelection = (pickupId, source = 'map') => {
    const pickup = this.props.DispatchStore.pickupsList.find(
      p => p.pickupId.toLowerCase() === pickupId.toLowerCase()
    );
    
    if (!pickup) return;
    
    let pickupIdsToEmit = [];
    
    if (pickup.groupId) {
      // This pickup is part of a group - select all pickups in the group
      const groupPickups = this.getGroupPickups(pickup.groupId);
      pickupIdsToEmit = groupPickups.map(p => p.pickupId);
    } else {
      // Single pickup - select just this pickup
      pickupIdsToEmit = [pickup.pickupId];
    }
    
    // Update dispatch store with selected pickup IDs
    this.props.glEventHub.emit('UpdateDispatchStore', 'updateSelectedPickups', [
      pickupIdsToEmit.map(id => id.toLowerCase())
    ]);
    
    // Emit pickup selection event to sync with grid
    this.props.glEventHub.emit(appConstants.Event.PICKUP_SELECTED_MAP, pickupIdsToEmit);
  };

  onPickupMarkerClicked = (pickup) => {
    this.pickupSelectedOnMap = true;
    this.isPickupMarkerClicked = true;
    this.isPickupMarkerHover = false;
    
    // Handle pickup selection and grid sync
    this.handlePickupSelection(pickup.data.pickupId, 'pickup-marker');
    
    // Handle popup and map state
    let pickupsToSelect = [];
    let selectedPickupForPopup = pickup;
    
    if (pickup.data.groupId) {
      // Select all pickups in the group
      const groupPickups = this.getGroupPickups(pickup.data.groupId);
      pickupsToSelect = groupPickups;

      // For popup, use the group header data from store to ensure we have group info
      const groupHeaderData = this.getGroupHeaderData(pickup.data.groupId);
      if (groupHeaderData) {
        selectedPickupForPopup = { 
          data: {
            ...groupHeaderData,
            latitude: groupHeaderData.shipperLatitude,
            longitude: groupHeaderData.shipperLongitude
          }
        };
      }
    } else {
      // Fallback for pickups without groupId
      pickupsToSelect = [pickup.data];
    }
    
    this.setState({
      selectedPickups: pickupsToSelect,
      selectedPickup: selectedPickupForPopup,
      recommendationPickupId: null
    });
  };

  onPickupMarkerHover = (pickup) => {
    if(!this.isPickupMarkerClicked ){
    this.pickupSelectedOnMap = true;
    this.isPickupMarkerClicked = false;
    this.isPickupMarkerHover = true;
    Events.emit("RemoveMapPopup");
    
    // If group header pickup is hovered, highlight entire group; otherwise highlight single pickup
    let pickupsToHighlight = [];
    let selectedPickupForPopup = pickup;
    
    if (isGroupHeaders(pickup.data) && pickup.data.groupId) {
      // This is a group header pickup - highlight all pickups in the group
      const groupPickups = this.getGroupPickups(pickup.data.groupId);
      pickupsToHighlight = groupPickups;

      // For popup, use the group header data from store to ensure we have group info
      const groupHeaderData = this.getGroupHeaderData(pickup.data.groupId);
      if (groupHeaderData) {
        selectedPickupForPopup = { 
          data: {
            ...groupHeaderData,
            latitude: groupHeaderData.shipperLatitude,
            longitude: groupHeaderData.shipperLongitude
          }
        };
      }
    } else {
      // Single pickup or non-group-header - highlight only this pickup
      pickupsToHighlight = [pickup.data];
    }
    
    this.setState({
      selectedPickups: pickupsToHighlight,
      selectedPickup: selectedPickupForPopup,
    });
   }
  };

  onHoverOutOnMap = () => {
    if (this.isPickupMarkerHover) {
      this.pickupSelectedOnMap = false;
      this.isPickupMarkerHover = false;
      this.setState({
        selectedPickups: [],
        selectedPickup: null,
      });
    }
  };

  onRouteStopClicked = (stop) => {   
    this.stopSelectedOnMap = true;
    this.pickupSelectedOnMap = false;
    this.isStopMarkerClicked = true;
    
    this.setState({
      selectedStop: stop,
    });
  };
  openMessageChatBox = (e, driverId) => {
    e.stopPropagation();
    this.props.glEventHub.emit(
      "OpenDriverChatBox",
      JSON.stringify({ driverId })
    );
  };

  hidePickupRecommendation = () => {
    this.setState({
      recommendationPickupId: null,
    });
  };

  handleSuccessPickupNotification = (pickupId, message, shouldUpdateSelection = false) => {
    if (this.props.configJSON.enableSuccessPickupNotification ?? true) {
      this.props.enqueueSnackbar(message, { variant: "success" });
    }
    const enableRouteSelection = this.props.configJSON?.routeSelection;
    // Only update selection if explicitly requested (i.e., when user initiated the action)
    if (shouldUpdateSelection && !enableRouteSelection) {
      this.updatePickupSelection(pickupId);
    }
  }

  handleAssignPickupNotification = (eventData, eventName, pendingPickupIds) => {
    const route = getPickupsRouteData(
      this.props.DispatchStore.routesList,
      eventData
    );
    if (!route) {
      return;
    }

    let pickupIds = [], isUserInitiatedAction=false;
    if (eventData.success) {
      pickupIds = [eventData.pickupId];
    } else {
      pickupIds = eventData.pickupIds;
    }
     // Normalize pickupIds to uppercase for consistent comparison
     const normalizedPickupIds = pickupIds.map(id => id?.toUpperCase());
     const normalizedPendingIds = (pendingPickupIds || []).map(id => id?.toUpperCase());
     
     // Check if action was user-initiated using case-insensitive comparison
     isUserInitiatedAction = normalizedPendingIds.some(id => 
       normalizedPickupIds.includes(id)
     );

    // Update pickup to show proper message in case of both success & failure
    const pickupsDetails = this.props.DispatchStore.pickupsList.filter(
      (p) => pickupIds.includes(p.pickupId?.toUpperCase())
    ).map(pickup => ` ${pickup.shipperName} (${pickup.pickupNumber})`).join(", ")
    if (!pickupsDetails) {
      return;
    }

    if (eventName === appConstants.PICKUP_EVENTS.ASSIGN_PICKUP) {
      if (eventData.success) {      
        const message = `Pickup ${pickupsDetails} assigned to route ${route.routeName}`;
       // Only update selection if user initiated the action
       this.handleSuccessPickupNotification(pickupIds[0], message, isUserInitiatedAction);
      } else {
        if (isUserInitiatedAction) {
          this.props.enqueueSnackbar(
            `Failed to assign pickup ${pickupsDetails} to driver ${route.driverName}`,
            { variant: "error" }
          );
        }
      }
    } else if (eventName === appConstants.PICKUP_EVENTS.UNASSIGN_PICKUP) {
      if (eventData.success) {
        const message = `Pickup  ${pickupsDetails} unassigned from route ${route.routeName}`;
        // Only update selection if user initiated the action
        this.handleSuccessPickupNotification(pickupIds[0], message, isUserInitiatedAction);
      } else {
        if (isUserInitiatedAction) {
          this.props.enqueueSnackbar(
            `Failed to unassign pickup  ${pickupsDetails} from driver ${route.driverName}`,
            { variant: "error" }
          );
        }
      }
    }
  };

  updatePickupSelection = (pickupId) => {
    const newSelectedPickups = this.state.selectedPickups.filter(
      (pickup) => pickup.pickupId?.toUpperCase() !== pickupId
    );
    this.setState({ selectedPickups: newSelectedPickups });
    this.props.glEventHub.emit(
      appConstants.Event.PICKUP_SELECTED_MAP,
      newSelectedPickups.map((pickup) => pickup.pickupId),
      false //refreshDriverSelection
    );
  };

  handleRecommendationsCloseButtonClick = () => {
    this.setState({
      recommendationPickupId: null,
      selectedPickups: [],
      selectedPickupsBackupData: [],
    });
    this.isPickupMarkerClicked = false;
    this.isPickupMarkerHover = false;
    this.props.glEventHub.emit(appConstants.Event.PICKUP_SELECTED_MAP, [], false);
  };

  assignPickupToDriver = (driverId) => {
    this.closePickupAssignmentLasso();
    assignPickup({
      assignPickupDetails: [{pickupId: this.state.recommendationPickupId, driverId, groupId:this.state.selectedPickup.data.groupId}],
      terminalCode: this.props.userData.userProfile.terminal.code,
      glEventHub: this.props.glEventHub,
      DispatchStore: this.props.DispatchStore,
      enqueueSnackbar: this.props.enqueueSnackbar
    }).then(() => {
      this.setState({
        selectedPickup: null,
        recommendationPickupId: null,
      });
      this.props.glEventHub.emit("SelectDriverRoutes", [driverId]);
    });
  };

  unAssignDriver = (pickupDetails) => {
    this.closePickupAssignmentLasso();
    unassignPickup({
      pickups: pickupDetails,
      driverId: pickupDetails[0].driverId,
      terminalCode: this.props.userData.userProfile.terminal.code,
      glEventHub: this.props.glEventHub,
      DispatchStore: this.props.DispatchStore,
    }).then(() => {
      this.setState({
        selectedPickup: null,
      });
    });
  };

  onRecommendationsButtonClick = (pickupId) => {
    this.setState(prevState => ({
      ...prevState,
      recommendationPickupId: pickupId,
      selectedPickupsBackupData: prevState.selectedPickups,
    }));
  };

  hideAllPopups = () => {
    if (
      this.state.selectedStop ||
      this.state.isPickupMove ||
      this.state.selectedPickup
    ) {
      this.isStopMarkerClicked = false;
      this.isPickupMarkerClicked =false;
      this.stopSelectedOnMap = false;
      this.pickupSelectedOnMap = false;
      this.setState({
        selectedStop: null,
        isPickupMove: false,
        selectedPickup: null,
      });
    }   
    Events.emit("RemoveMapPopup");
  };

  getGeocodeCustomer = (groupId) => {
      if (this.state.selectedStop?.data) {
      // Pickup or delivery Stops
      return getStopCustomerData(this.state.selectedStop.data);
    } else {
      // For unassigned Pickups
      const unassignedPickupId = groupId || (
        this.state.selectedPickup?.data?.groupId ||
        this.state.selectedPickups[0].groupId
      );
      const unassignedPickups = this.props.DispatchStore.pickupsList.filter(
        (pickup) =>
          pickup.groupId.toLowerCase() === unassignedPickupId.toLowerCase()
      );

      if (unassignedPickups.length === 0) {
        return null;
      }
      return getPickupCustomerData(unassignedPickups);
    }
  };

  getPickupTerminalList = () => {
    if(!this.enableChangePickupTerminal) {
      return;
    }
    getDataWithQueryString(
      "GetTerminalsToMovePickup",
      `terminalCode=${this.props.userData.userProfile.terminal.code}`
    )
      .then((response) => {
        if (response.status === 200) {
          this.props.DispatchStore.setMovePickupTerminalList(response.data);
        } else {
          this.props.DispatchStore.setMovePickupTerminalList([]);
        }
      })
      .catch((error) => {
        this.props.DispatchStore.setMovePickupTerminalList([]);
      });
  };

  onDriverIconClick = (route) => {
    this.props.glEventHub.emit(
      "SelectDriverRoutes",
      [route.data.driverId],
      false,
      true,
      this.showRouteAnimation
    );
  };

  disableRouteAnimation = () => {
    if (this.showRouteAnimation) {
      this.handleRouteAnimation(false);
    }
  };

  handleRouteAnimation = (showRouteAnimation) => {
    this.showRouteAnimation = showRouteAnimation;
  };

  getMarkerLayerCenter = () => {
    // If route animation is off, disable pickup auto Zoom 
    if (!this.state.routeAnimation) {
      return this.props.userData.userProfile.terminal.location;
    }
   // If a single marker is selected on grid or on Map move map to make that shipment as center
     const { selectedPickup, selectedPickups } = this.state;
    if (!this.isPickupMarkerHover) {
      if (selectedPickup) {
        return {
          lat: selectedPickup.data.shipperLatitude,
          lng: selectedPickup.data.shipperLongitude,
        };
      }
      if (selectedPickups.length) {
        // For group selection, center on the first pickup in the group
        const firstPickup = selectedPickups[0];
        if (firstPickup.position) {
          return firstPickup.position;
        } else if (firstPickup.shipperLatitude && firstPickup.shipperLongitude) {
          return {
            lat: firstPickup.shipperLatitude,
            lng: firstPickup.shipperLongitude,
          };
        }
      }
    }
    return null;
  };

  getPickupIcon = (pickup) => {
    const {
      theme,
    } = this.props;
    const isPickupActive = isPickupOnMapActive(
      this.state.selectedPickups,
      pickup.pickupId
    );
    let marker = "";
    if (pickup.driverId && pickup?.isPickupDriverExistInGrid) {
      const pickupStop = getPickupStopData(this.props.DispatchStore.routesList, pickup);
      marker = getDispatchAssignedPickupMarker({
        pickup: pickup,
        stopData: pickupStop?.stopData,
        isPickupActive: isPickupActive,
        stopSequence: pickupStop?.stopData?.stopSequence,
        color: pickupStop?.stopColor,
        theme,
      });
    } else {
      marker = getDispatchUnassignedPickupMarker({
        isActive: isPickupActive,
        theme,
        pickupCount: getPickupCountForPickupMarkerBadge(pickup),
        pickupStatus: getPickupStatus({pickup, terminalOffset: this.props.DispatchStore.terminalOffset, newPickupDuration:this.props.configJSON.newPickupDuration})
      }) 
    }
    return marker;
  };

  isDriverRouteShown = (driverId) => {
    return (
      this.props.DispatchStore.routesWithFilteredStops.findIndex(
        (route) => route.driverId === driverId
      ) > -1
    );
  };

  getVisiblePickups() {
    const { routesWithFilteredStops, filteredPickups, currentActiveRoutes } = this.props.DispatchStore;
    const visibleRouteIds = new Set(routesWithFilteredStops.map(route => route.routeId?.toLowerCase()));

    return filteredPickups
      .filter(pickup => {
        // Filter out pickups that are already shown as route stops
        const pickupRouteId = pickup.routeId?.toLowerCase();
        if (pickupRouteId && visibleRouteIds.has(pickupRouteId)) {
          return false;
        }
        
        // For grouped pickups, show group headers and single pickups in groups
        if (pickup.groupId) {
          return isPickupGroupHeader(pickup);
        }
        
        // Show individual pickups (no groupId)
        return true;
      })
      .map(pickup => ({
        ...pickup,
        latitude: pickup.shipperLatitude,
        longitude: pickup.shipperLongitude,
        isPickupDriverExistInGrid: isPickupDriverExistInGrid({
          currentActiveRoutes,
          driverId: pickup.driverId,
          routeId: pickup.routeId
        })
      }));
  }

  getMarkerLabel = (pickup) => {
    const pickupStatus = getPickupStatus({
      pickup:pickup,
      terminalOffset: this.props.DispatchStore.terminalOffset,
      newPickupDuration: this.props.configJSON?.newPickupDuration
  });
    if (
      [PICKUP_STATUS.completed, PICKUP_STATUS.voided].includes(pickupStatus)
    ) {
      return null;
    }
    return `${pickup.pickupReadyTime}
            ${pickup.pickupCloseTime}`;
  };

  getBadgeLabel = (pickup) => {
    return pickup.pickupNumberIdList?.length > 1
    ? pickup.pickupNumberIdList.length
    : null;
  };

  getMarkerLabelProps = () => {
    return {
      layout: {
        "text-offset": [-1.5, 0.3],
        "text-anchor": "right",
        "text-size": 10,
      },
      paint: {
        "text-color":
          'modernDark' === this.props.theme.themeName ? "#FFFFFF" : "#000000",
        "text-opacity": 0.8,
      },
    };
  };

  showPickupPopup = (selectedPickup) => {
    if (!selectedPickup) {
      return false;
    }
    
    // Only show popup for map marker clicks or hover - NOT for grid selections
    return this.isPickupMarkerClicked || this.isPickupMarkerHover;
  };

  onMouseLeftStopMarker=()=>{
    if(!this.isStopMarkerClicked && this.isHoverStopMarker){
      this.isHoverStopMarker = false;
      this.stopSelectedOnMap = false;
      this.setState({
        selectedStop: null,
      });
    }
  }

  onStopMarkerHover=(stop)=>{
    if (!this.isStopMarkerClicked){
      this.stopSelectedOnMap = true;
      this.isStopMarkerClicked = false;
      this.isHoverStopMarker = stop.isHoverStop
      this.setState({
        selectedStop: stop,
      });
      Events.emit("RemoveMapPopup");
    }
  }

  onShowActualRouteToggleClick = (data, checked) => {  
    const gpsManagerData = {
      driverId: checked ? data.driverId : null,
      showActualRoute: checked
    }
    this.setState({ gpsManagerData});
  };

  render() {
    const {
      theme,
      DispatchStore,
      userData: { userProfile },
      glEventHub,
      configJSON: { closingSoonWarningTimeLimit, closingSoonAlertTimeLimit },
      styleName
    } = this.props;
    const { selectedPickup, selectedStop, recommendationPickupId } = this.state;
    const specialNeeds = getSpecialNeedsOptionsWithServiceLevel(DispatchStore.priorityAllShipmentList);
    const { offset, location: terminalLocation } = userProfile.terminal;
    const showOnHoverPopup = DispatchStore.showOnHoverPopup;
    const selectedDispatchDriverIdList =
      DispatchStore.selectedDispatchDriverIdList;
    let selectedRoutes = DispatchStore.routesWithFilteredStops.slice();
    let selectedDriversWithDispatch = [];
    let routesData;
    if (selectedPickup?.data?.driverId) {
      routesData = DispatchStore.getCurrentDriver(
        selectedPickup?.data?.driverId
      );
    } else if (selectedStop) {
      routesData = DispatchStore.getCurrentDriver(selectedStop.data.driverId);
    }
    if (selectedDispatchDriverIdList.length) {
      selectedDriversWithDispatch =
        DispatchStore.getSelectedDriverCurrentRoutes().map((route) => ({
          routeId: "",
          ...route,
          filteredStops: []         
        }));
    }

    const showStopList =
      selectedRoutes?.length === 1 || selectedDriversWithDispatch.length === 1;

    const futurePickup = isFuturePickup(
      selectedPickup?.data.pickupDate,
      DispatchStore.terminalOffset
    );

    let isPickupStopPopup = false,
      isDeliveryStopPopup = false,
      stopPopupCommonProps = {};
    if (this.stopSelectedOnMap && selectedStop) {
      isPickupStopPopup =
        selectedStop?.data?.stopType === appConstants.STOP_TYPE.Pickup;
      isDeliveryStopPopup =
        selectedStop?.data?.stopType === appConstants.STOP_TYPE.Delivery;
      stopPopupCommonProps = {
        glEventHub,
        stopData: selectedStop.data,
        routesData,
        specialNeeds,
        isDelayStop: hasStopDelayed(selectedStop.data),
        terminalOffset: offset,
        openDriverChat: this.openMessageChatBox,
      };
    }
    const closingSoonLimitConfig = {
      closingSoonWarningTimeLimit,
      closingSoonAlertTimeLimit
    }
    
    return (
      <div id={showStopList ? "showStopList" : ""}>
        {showStopList && (
          <DriverPopup
            routeData={selectedRoutes?.[0] || selectedDriversWithDispatch[0]}
            userProfile={userProfile}
            glEventHub={glEventHub}
            defaultExpanded={Boolean(this.props.DispatchStore.selectedStopInKPI)}
            stopId={this.props.DispatchStore.selectedStopInKPI}
            key={selectedRoutes?.[0]?.driverId || selectedDriversWithDispatch[0]?.driverId} // need this for priority shipment link 
          />
        )}

        {recommendationPickupId &&
          checkPickupExists({
            filteredPickups: DispatchStore.filteredPickups,
            selectedPickupsList: this.state.selectedPickupsBackupData,
            pickupId: recommendationPickupId,
          }) &&
          isPickupUnassigned(
            this.state.selectedPickupsBackupData,
            recommendationPickupId
          ) && (
            <ShowBestDriversDialog
              handleClose={this.handleRecommendationsCloseButtonClick}
              selectedPickupInfo={selectedPickup.data}
              assignPickup={this.assignPickupToDriver}
              glEventHub={glEventHub}
            />
          )}
        <Marker
          position={terminalLocation}
          zIndex={1}
          forceUpdate
          isActiveShipment
          easeToAnimation
          mapZoomLevel={appConstants.MAP_ZOOM_LEVEL}
        >
          <TerminalMarker
            data={userProfile.terminal}
            color={theme.terminalContentColor}
          />
        </Marker>

        <MarkerLayer
          code={this.props.userData.userProfile.terminal.code}
          data={this.getVisiblePickups()}
          dataKey={'pickupId'}
          activeMarkerIds={!this.isPickupMarkerHover ? this.state.selectedPickups.map((pickup) => pickup.pickupId?.toLowerCase()) : []}
          thresholdZoomLevel={appConstants.STOP_POPUP_THRESHOLD_ZOOM_LEVEL}
          getIcon={this.getPickupIcon}
          center={this.getMarkerLayerCenter()}
          onClick={(pickup) => this.onPickupMarkerClicked({ data: pickup })}
          onMouseHover={(pickup) => this.onPickupMarkerHover({ data: pickup })}
          getMarkerLabel={this.getMarkerLabel}
          getBadgeLabel={this.getBadgeLabel}
          markerLabelProps={this.getMarkerLabelProps()}
          showTooltip={false}
          styleName={styleName}
          showOnHoverPopup={showOnHoverPopup && !this.isPickupMarkerClicked && !this.isHoverStopMarker }
        />

       <SpottedTrailers
          headerId={this.headerId}
          glEventHub={this.props.glEventHub}
          terminalCode={userProfile.terminal.code}
          onHoverOutOnMap={this.onHoverOutOnMap}
          onMouseLeftStopMarker={this.onMouseLeftStopMarker}
        />

        {this.state.gpsManagerData?.showActualRoute && <GpsPingsManager
          DispatchStore={DispatchStore}
          userData={this.props.userData}
          theme={theme}
          gpsManagerData={this.state.gpsManagerData}
          routeData={selectedRoutes}
        />}

        <RouteDirections
          stopsFieldName="filteredStops"
          selectedRoutes={selectedRoutes}
          terminalLocation={terminalLocation}
          disableRouteAnimation={this.disableRouteAnimation}
          routeAnimation={this.state.routeAnimation}
          showRouteAnimation={this.showRouteAnimation}
        />
        <DriverMarkers
          isDriverRouteShown={this.isDriverRouteShown}
          theme={theme}
          onDriverIconClick={this.onDriverIconClick}
          openMessageChatBox={this.openMessageChatBox}
          onShowActualRouteToggleClick={this.onShowActualRouteToggleClick}
          enableDriverActualRoute={this.props.configJSON?.enableDriverActualRoute}
          showActualRoute={this.state.gpsManagerData?.showActualRoute}  
        />

        {selectedRoutes?.map((route) =>
          route.filteredStops?.map((stop) => (
            <Marker
              data={{ ...stop }}
              position={{ lat: stop.latitude, lng: stop.longitude }}
              key={`${stop.stopId}_${stop.stopSequence}`}
              zIndex={stop.stopId === selectedStop?.data?.stopId ? 2 : 1}
              onClick={this.onRouteStopClicked}
              onMouseHover={this.onStopMarkerHover}
              showOnHoverPopup={showOnHoverPopup && !this.isStopMarkerClicked && !this.isPickupMarkerHover}
              thresholdZoomLevel={appConstants.STOP_POPUP_THRESHOLD_ZOOM_LEVEL}
              onMouseOut={this.onMouseLeftStopMarker}
            >
              {getDispatchRouteStopsMarker({
                stop,
                ...getStopMarkerColors({
                  theme,
                  stop,
                  routeColor: route.color,
                }),
                isSelectedStop: !Boolean(selectedStop?.isHoverStop) && Boolean(
                  selectedStop?.data?.stopId === stop.stopId
                ),
              })}
            </Marker>
          ))
        )}
        <MapLegend
          defaultVisible={this.driversMapConfig.toggles.isMapLegendEnabled}
          glEventHub={this.props.glEventHub}
          enableDriverActualRoute={this.props.configJSON?.enableDriverActualRoute}
        />

        {this.showPickupPopup(selectedPickup) && (
          <Popup
            position={{
              lat: selectedPickup.data.latitude || selectedPickup.data.shipperLatitude,
              lng: selectedPickup.data.longitude || selectedPickup.data.shipperLongitude,
            }}
            key={`${selectedPickup.data.pickupId}_pickupPopup`}
          >
            <PickupPopupInfo
              specialNeeds={specialNeeds}
              routesData={routesData}
              selectedPickup={selectedPickup.data}
              enqueueSnackbar={this.props.enqueueSnackbar}
              showAction={
                !(
                  futurePickup ||
                  selectedPickup.data.isCompleted ||
                  selectedPickup.data.isVoided ||
                  selectedPickup.data.isMissed
                )
              }
              terminal={userProfile.terminal}
              enableChangePickupTerminal={this.enableChangePickupTerminal}
              routesList={DispatchStore.routesList}
              currentActiveRoutes={DispatchStore.currentActiveRoutes}
              unAssignDriver={this.unAssignDriver}
              openMessageChatBox={this.openMessageChatBox}
              onRecommendationsButtonClick={this.onRecommendationsButtonClick}
              terminalCodeList={this.props.DispatchStore.movePickupTerminalList}
              glEventHub={this.props.glEventHub}
              closingSoonLimitConfig = {closingSoonLimitConfig}
              marker={getPickupStatusTypeIcon({
                theme,
                status: getPickupStatus({
                  pickup: selectedPickup.data,
                  terminalOffset: this.props.DispatchStore.terminalOffset,
                  newPickupDuration: this.props.configJSON?.newPickupDuration
                })
              })}
            />
          </Popup>
        )}

        {isDeliveryStopPopup && (
          <Popup
            marker={selectedStop.marker}
            // forceRender will rerender the child component into the infowindow,
            // set to true when theme changes or data is updated for selected shipment
            // forceRender={this.state.themeChanged}
          >
            <DispatchStopDeliveryPopupInfo {...stopPopupCommonProps} />
          </Popup>
        )}

        {isPickupStopPopup && (
          <Popup
            key={selectedStop.stopId}
            marker={selectedStop.marker}
            // forceRender will rerender the child component into the infowindow,
            // set to true when theme changes or data is updated for selected shipment
            // forceRender={this.state.themeChanged}
          >
            <DispatchStopPickupPopupInfo
              {...stopPopupCommonProps}
              hideAction={selectedStop.data.isStopCompleted}
              unAssignDriver={this.unAssignDriver}
              pickupNumber={selectedStop.data.pickupNumber}
              closingSoonLimitConfig={closingSoonLimitConfig}
              pickupId={selectedStop.data.pickupId}
            />
          </Popup>
        )}

        {this.lassoBounds?.length ? (
          ReactDOM.createPortal(<PickupAssignmentLasso
            unassignedPickups={this.state.lassoUnassignedPickups}
            userProfile={userProfile}
            glEventHub={glEventHub}
            close={this.closePickupAssignmentLasso}
          />, document.getElementById("dispatchMapContainer"))
        ) : null}

        {this.state.geocodeCustomer ? (
          <GeocodingModal
            customer={this.state.geocodeCustomer}
            userData={userProfile}
            close={this.closeGeocodeModal}
          />
        ) : null}
      </div>
    );
  }
}

export default compose(
  withSnackbar,
  withFeatureFlags,
  WithPickupsGridFilterHOC
)(DriverMapContent);

